import Configs from "../../vendorConfigs/Configs";
import GameModel from "../../../core/src/model/GameModel";
import { IRequestBuilder } from "../../../core/src/server/requests/RequestBuilder";


export default class GetBalanceRequest implements IRequestBuilder {
    get method() {
      return "POST";
    }
  
    get path() {
      return Configs.game.clientConfig.gameServerApi + "/getbalance"
    }
  
    get requestData() {
      return {
        sid: GameModel.sessionID
      }
    }
  }